import { ResolveFn } from '@angular/router';
import { inject } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  ACE_TRANSCRIPTION_API_ACTIONS,
  AUDIO_API_ACTIONS,
  CONTACT_DETAILS_API_ACTIONS,
  CONVERSATION_DETAILS_API_ACTIONS,
  CONVERSATION_IDS_API_ACTIONS,
  STANDARD_TRANSCRIPTION_API_ACTIONS,
} from '../../store/actions';

export const conversationResolver: ResolveFn<unknown> = (): boolean => {
  const store = inject(Store);

  store.dispatch(STANDARD_TRANSCRIPTION_API_ACTIONS.get());
  store.dispatch(ACE_TRANSCRIPTION_API_ACTIONS.get());
  store.dispatch(AUDIO_API_ACTIONS.get());
  store.dispatch(CONVERSATION_IDS_API_ACTIONS.get());
  store.dispatch(CONTACT_DETAILS_API_ACTIONS.get());
  store.dispatch(CONVERSATION_DETAILS_API_ACTIONS.get());

  return true;
};
